<template>
  <fragment>
    <ModalitySelection
      :items="value.modalidades"
      :error-messages="modalityErrorMessage"
      title="MODALIDADES"
      v-bind="[$attrs, $props]"
      v-on="$listeners"
      type-item="modality"
    />
    <BaseFooter>
      <div class="d-flex justify-end">
        <BaseButton
          class="error text-uppercase subtitle-2 font-weight-bold"
          min-width="200"
          @click="$emit('cancel')"
        >
          CANCELAR
        </BaseButton>
        <BaseButton
          type="submit"
          class="secondary text-uppercase subtitle-2 font-weight-bold ml-5"
          min-width="200"
        >
          SALVAR
        </BaseButton>
      </div>
    </BaseFooter>
  </fragment>
</template>
<script>
import ModalitySelection from "../../../components/form/ModalitySelection";
export default {
  nextStep() {
    return import("./ConfigureModality.vue").then(c => c.default);
  },
  previousStep() {
    return import("./ConfigureLimit.vue").then(c => c.default);
  },
  components: {
    ModalitySelection
  },
  props: {
    value: Object,
    modalityErrorMessage: Array
  }
};
</script>
